module.exports = __webpack_public_path__ + "static/media/mode-37.f8a1cb81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-37.svg
// module id = 1010
// module chunks = 2